import { Tab, Tabs } from '@mui/material';
import { NavLink } from 'react-router-dom';

import { useRouteMatch } from '@utils/routes.utils';

interface RoutesTabsComponentProps {
  ariaLabel?: 'primary' | 'secondary';
  handleChange?: () => void;
  routes: { label: string; path: string; disabled?: boolean }[];
  variant?: 'fullWidth' | 'standard';
}

const RoutesTabsComponent = (props: RoutesTabsComponentProps) => {
  const { ariaLabel = 'primary', handleChange, routes, variant = 'standard' } = props;

  const currentTab = useRouteMatch(routes.map((route) => route.path));

  return (
    <Tabs aria-label={ariaLabel} variant={variant} onChange={handleChange} value={currentTab || routes[0]?.path}>
      {routes.map((route, index) => (
        <Tab
          key={`Tab ${index} - ${route.label}`}
          label={route.label}
          component={NavLink}
          to={route.path}
          disabled={route.disabled || false}
          value={route.path} />
      ))}
    </Tabs>
  );
};

export default RoutesTabsComponent;
